import { AuthenticatorRegistrationEntity } from '../entities';
import { authResource } from './Auth';
export const AccountAuthenticatorResource = authResource({
    path: '/accounts/:accountId/authenticator/register/',
    schema: AuthenticatorRegistrationEntity
}).extend((BaseResource) => ({
    register: BaseResource.update.extend({
        method: 'POST',
        body: {
            code: ''
        },
        schema: undefined
    }),
    updateStatus: BaseResource.update.extend({
        path: '/accounts/:accountId/authenticator/status',
        method: 'POST',
        body: {
            isEnabled: false,
            userId: ''
        },
        schema: undefined,
        process: (response) => {
            if (response !== true) {
                throw new Error();
            }
            return undefined;
        }
    })
}));
